export class CheckArgs {
  /**
   *
   * @param object
   * @returns true - if object is null/undefined/""
   */
  static CheckNullOrUndefinedOrEmptyString(object: unknown): boolean {
    return (
      object === null ||
      object === undefined ||
      (typeof object === "string" && object === "")
    );
  }

  /**
   *
   * @param object
   * @returns true - if object is not empty array
   */
  static CheckArrayAndNotEmpty(object: any) {
    return Array.isArray(object) && object.length !== 0;
  }
}
